import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useAppAdoptionFeatures } from "../../hooks/useAppAdoptionFeatures";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import styles from "./AppExclusive.scss";

const AppExclusive = () => {
  const { getTranslation, product, isMixAndMatch } = useRuntimeConstants();
  const { customerAccess } = getCustomerLoyaltyAccess(product, isMixAndMatch);
  const showDownloadApp = useAppAdoptionFeatures(customerAccess);

  if (!showDownloadApp) {
    return null;
  }

  return (
    <div className={styles.appExclusive}>
      <p className={styles.title}>
        {getTranslation("download_the_app_app_exclusive_title")}
      </p>
      <p className={styles.description}>
        <span>{getTranslation("pdp_banner_only_on_app_message")}</span>
      </p>
    </div>
  );
};

export default AppExclusive;
